import axios from "axios"

async function getCustomersApi(){
    return axios({
        method: "GET",
        url: `/api/v1/db-customers`
    })
}

async function getCustomerApi(id: string){
    return axios({
        method: "GET",
        url: `/api/v1/db-customers/${id}`
    })
}

async function getCustomersToAllocateApi(){
    return axios({
        method: "GET",
        url: `/api/v1/customers-unallocated`
    })
}

export {
    getCustomersApi,
    getCustomerApi,
    getCustomersToAllocateApi
}